module.exports = __webpack_public_path__ + "static/img/main_point_img01.230c036c.svg";